// 测试环境地址
// export const dev_port = 'http://139.196.146.86/dnf/'
//正式环境接口地址
export const dev_port = 'http://106.15.170.130/dnf/'  
// export const dev_port='http://47.102.122.200/dnf/'
export const signin = dev_port + 'rest/signin'
export const Login = dev_port + 'rest/login'
export const is_signin = dev_port + 'rest/is-signin'
export const my_prize = dev_port + 'rest/my-prize'
export const logout = dev_port + 'rest/logout'
export const my_address = dev_port + 'rest/my-address'
export const draw = dev_port + 'rest/draw'
export const quiz_topic = dev_port + 'rest/quiz-topic'
export const fill_qq = dev_port + 'rest/fill-qq'
export const fill_address = dev_port + 'rest/fill-address'
export const is_login = dev_port + 'rest/is-login'
export const my_points = dev_port + 'rest/my-points'
export const quiz_answer = dev_port + 'rest/quiz-answer'
export const award = dev_port + 'rest/award'
export const prize_list = dev_port + 'rest/prize-list'
